import React, { useState } from 'react';
import './SurveyStep.css';

// 7가지 학생용 핵심 설문 질문
const surveyQuestions = [
  {
    id: 1,
    title: "쉬는 시간에 주로 어떻게 지내나요?",
    description: "10분 쉬는 시간이나 점심시간에 주로 무엇을 하며 보내는지",
    leftLabel: "조용히 책이나 그림",
    rightLabel: "활발하게 친구들과 놀기",
    leftValue: "조용한 활동",
    rightValue: "활발한 활동"
  },
  {
    id: 2,
    title: "수업 중 모르는 게 있을 때 어떻게 하나요?",
    description: "수업 시간에 이해가 안 되는 내용이 나왔을 때의 반응",
    leftLabel: "혼자 생각해서 해결",
    rightLabel: "바로 질문하고 토론",
    leftValue: "독립적 해결",
    rightValue: "적극적 질문"
  },
  {
    id: 3,
    title: "처음 해보는 활동이 있을 때 기분은?",
    description: "새로운 게임, 수업, 프로젝트 등을 처음 접했을 때",
    leftLabel: "신중하게 관찰 먼저",
    rightLabel: "바로 도전하고 시도",
    leftValue: "신중한 접근",
    rightValue: "즉각적 도전"
  },
  {
    id: 4,
    title: "친구와 의견이 다를 때 어떻게 하나요?",
    description: "모둠 활동이나 게임에서 친구와 생각이 다를 때",
    leftLabel: "논리적으로 설명",
    rightLabel: "감정을 이해하며 대화",
    leftValue: "논리적 설득",
    rightValue: "공감적 소통"
  },
  {
    id: 5,
    title: "모둠 활동에서 주로 맡는 역할은?",
    description: "팀 프로젝트나 모둠 활동을 할 때 자주 하는 역할",
    leftLabel: "계획 세우고 정리",
    rightLabel: "아이디어 내고 실행",
    leftValue: "계획 및 조직",
    rightValue: "창의 및 실행"
  },
  {
    id: 6,
    title: "자유시간에 가장 하고 싶은 것은?",
    description: "주말이나 방학처럼 자유롭게 시간을 쓸 수 있을 때",
    leftLabel: "조용히 혼자 집중",
    rightLabel: "친구들과 함께 활동",
    leftValue: "혼자 활동",
    rightValue: "함께 활동"
  },
  {
    id: 7,
    title: "원하는 것을 이루기 위해 어떻게 하나요?",
    description: "목표나 꿈을 달성하기 위한 나만의 방법",
    leftLabel: "차근차근 계획대로",
    rightLabel: "즉흥적으로 유연하게",
    leftValue: "계획적 접근",
    rightValue: "유연한 접근"
  }
];

const SurveyStep = ({ onComplete, onBack }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [selectedValue, setSelectedValue] = useState(null);

  const handleCircleSelect = (value) => {
    setSelectedValue(value);
  };

  const handleNext = () => {
    const question = surveyQuestions[currentQuestion];
    setAnswers(prev => ({
      ...prev,
      [question.id]: {
        value: selectedValue,
        leftValue: question.leftValue,
        rightValue: question.rightValue,
        question: question.title
      }
    }));

    if (currentQuestion < surveyQuestions.length - 1) {
      setCurrentQuestion(prev => prev + 1);
      setSelectedValue(null); // 다음 질문으로 넘어갈 때 선택값 초기화
    }
  };

  const handlePrev = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(prev => prev - 1);
      // 이전 답변이 있으면 선택값 복원
      const prevQuestion = surveyQuestions[currentQuestion - 1];
      const prevAnswer = answers[prevQuestion.id];
      setSelectedValue(prevAnswer?.value || null);
    }
  };

  const handleComplete = () => {
    const question = surveyQuestions[currentQuestion];
    const finalAnswers = {
      ...answers,
      [question.id]: {
        value: selectedValue,
        leftValue: question.leftValue,
        rightValue: question.rightValue,
        question: question.title
      }
    };
    onComplete(finalAnswers);
  };

  const progress = ((currentQuestion + 1) / surveyQuestions.length) * 100;
  const question = surveyQuestions[currentQuestion];
  const isLastQuestion = currentQuestion === surveyQuestions.length - 1;
  const hasAnswered = selectedValue !== null; // 선택되었는지 확인

  return (
    <div className="student-profile-event-survey-step">
      <div className="student-profile-event-survey-container">
        {/* 헤더 */}
        <div className="student-profile-event-survey-header">
          <button 
            className="student-profile-event-back-button"
            onClick={onBack}
          >
            ← 이전으로
          </button>
          <div className="student-profile-event-question-counter">
            {currentQuestion + 1} / {surveyQuestions.length}
          </div>
        </div>

        {/* 진행률 - 간단한 수치만 표시 */}
        <div className="student-profile-event-progress-simple">
          <div className="student-profile-event-progress-text">
            {Math.round(progress)}% 완료
          </div>
        </div>

        {/* 질문 카드 */}
        <div className="student-profile-event-question-card">
          <div className="student-profile-event-question-number">
            Q{question.id}
          </div>
          
          <h2 className="student-profile-event-question-title">
            {question.title}
          </h2>
          
          <p className="student-profile-event-question-description">
            {question.description}
          </p>

          {/* 선택 섹션 */}
          <div className="student-profile-event-selection-section">
            <div className="student-profile-event-selection-labels">
              <div className="student-profile-event-selection-label left">
                {question.leftLabel}
              </div>
              <div className="student-profile-event-selection-label right">
                {question.rightLabel}
              </div>
            </div>

            <div className="student-profile-event-circles-container">
              {[1, 2, 3, 4, 5, 6, 7].map((value) => (
                <button
                  key={value}
                  className={`student-profile-event-circle ${selectedValue === value ? 'selected' : ''}`}
                  onClick={() => handleCircleSelect(value)}
                  type="button"
                >
                  <span className="student-profile-event-circle-number">{value}</span>
                </button>
              ))}
            </div>

            <div className="student-profile-event-selection-scale">
              <div className="student-profile-event-scale-description left">
                매우 그렇다
              </div>
              <div className="student-profile-event-scale-description center">
                보통
              </div>
              <div className="student-profile-event-scale-description right">
                매우 그렇다
              </div>
            </div>
          </div>

          {/* 네비게이션 버튼 */}
          <div className="student-profile-event-navigation">
            <button
              className="student-profile-event-prev-button student-profile-event-nav-button"
              onClick={handlePrev}
              disabled={currentQuestion === 0}
            >
              <span>← 이전</span>
            </button>

            {isLastQuestion ? (
              <button
                className="student-profile-event-complete-button student-profile-event-nav-button"
                onClick={handleComplete}
                disabled={!hasAnswered}
              >
                <span>분석 시작하기</span>
              </button>
            ) : (
              <button
                className="student-profile-event-next-button student-profile-event-nav-button"
                onClick={handleNext}
                disabled={!hasAnswered}
              >
                <span>다음</span>
                <span>→</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SurveyStep;
